import { render, staticRenderFns } from "./DVfield.vue?vue&type=template&id=40ea6fb0&scoped=true"
import script from "./DVfield.vue?vue&type=script&lang=js"
export * from "./DVfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea6fb0",
  null
  
)

export default component.exports